import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Choice, OneOfManyQuestion } from '@models/Survey'
import { AnswerType } from '@models/Survey/Answer'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { SurveyContext } from '@context/SurveyContext'
import { NavigationContext } from '@context/NavigationContext'
import { TabbedPane } from '@components/Survey/TabbedPane/TabbedPane'
import './AcknowledgeUser.scss'
import { usePreventBackNavigation } from '@hooks/usePreventBackNavigation'
import {
  categorySkipsPredictionStep,
  getCategory,
  isLastSurveyInCategory,
} from '@utils/categoryFlow'

export function AcknowledgeUser() {
  usePreventBackNavigation()
  const { t } = useTranslation('AcknowledgeUser')
  const { setPrevHandler, setNextHandler } = useContext(NavigationContext)
  const { survey, setAcknowledge, setNextStep, submitAnswers, setResultVariant, surveyIsCompleted } =
    useContext(SurveyContext)

  useEffect(() => {
    setPrevHandler(undefined)
    return () => {
      setPrevHandler(undefined)
      setNextHandler(undefined)
    }
  }, [])

  const meId = 'me'
  const choices = [
    {
      id: meId,
      text: `> ${t('choices.me')}`,
    },
    {
      id: 'test',
      text: `> ${t('choices.other')}`,
    },
  ] as Choice[]
  const question = {
    choices,
  } as OneOfManyQuestion

  const handleAcknowledge = (answer: AnswerType) => {
    // "me" → true, "test" → false (persisted as confirmation); both unlock Next.
    setAcknowledge(answer === meId)

    const category = getCategory(survey)

    if (categorySkipsPredictionStep(category, survey)) {
      setNextHandler(() => {
        if (!surveyIsCompleted) {
          setNextStep(SurveyStep.Answer)
          return
        }
        // Intermediate stages → continue CTA; last stage should be final (rare skip path).
        setResultVariant(isLastSurveyInCategory(survey) ? 'final' : 'intermediate')
        submitAnswers().then(() => setNextStep(SurveyStep.Results))
      })
      return
    }

    setNextHandler(() => setNextStep(SurveyStep.Prediction))
  }

  const tabs = [
    {
      text: t('navigation.title'),
    },
  ]
  return (
    <TabbedPane
      tabs={tabs}
      contentText={t('questionText')}
      choices={question}
      onChoiceSelection={handleAcknowledge}
      propClassName="AcknowledgeUser"
    />
  )
}

export default AcknowledgeUser
